import { useAtom } from 'jotai'

import { isContractExtractionEnabledExternallyAtom } from 'ContractExtraction/atoms'

/**
 * Hook for allowing external dependencies like Cube to control if performing a contract extraction
 * is enabled or not
 */
export const useEnableContractExtraction = () => {
  const [, set] = useAtom(isContractExtractionEnabledExternallyAtom)
  return set
}
